import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=24f45d9f&scoped=true"
import script from "./Full.vue?vue&type=script&setup=true&lang=js"
export * from "./Full.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Full.vue?vue&type=style&index=0&id=24f45d9f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f45d9f",
  null
  
)

export default component.exports